import mock from '@/@fake-db/mock'
import jwt from 'jsonwebtoken'

import axios from '@axios'
import { subject } from '@casl/ability'

const data = {
  users: [
    {
      id: 1,
      fullName: 'John Doe',
      username: 'johndoe',
      password: 'admin',
      // eslint-disable-next-line global-require
      avatar: require('@/assets/images/avatars/13-small.png'),
      email: 'admin@demo.com',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all',
        },
      ],
      extras: {
        eCommerceCartItemsCount: 5,
      },
    },
    {
      id: 2,
      fullName: 'Jane Doe',
      username: 'janedoe',
      password: 'client',
      // eslint-disable-next-line global-require
      avatar: require('@/assets/images/avatars/1-small.png'),
      email: 'client@demo.com',
      role: 'client',
      ability: [
        {
          action: 'read',
          subject: 'ACL',
        },
        {
          action: 'read',
          subject: 'Auth',
        },
      ],
      extras: {
        eCommerceCartItemsCount: 5,
      },
    },
  ],
}

// ! These two secrets shall be in .env file and not in any other file
const jwtConfig = {
  secret: 'dd5f3089-40c3-403d-af14-d0c228b05cb4',
  refreshTokenSecret: '7c4c1c50-3230-45bf-9eae-c9b2e401c767',
  expireTime: '10m',
  refreshTokenExpireTime: '10m',
}

mock.onPost('/jwt/login').reply(async request => {
  console.log('request',request);
 // const test = await axios.post('users/v1/login', request.data);
  const res = await axios.post('users/v1/login', request.data);
  console.log('login111', res)
  let user = null;
  if(res.data.success){
    user = res.data.data;
  }
  console.log('user555',user);
  
  //const { email, password } = JSON.parse(request.data)

  let error = {
    email: ['Something went wrong'],
  }
  

  //const user = data.users.find(u => u.email === email && u.password === password)

  if (user) {
  
    if(user.role === 'Super Admin'){
      user.ability = [
        {
          action: 'manage',
          subject: 'all',
        },
      ];
    }else if(user.role === 'Sale Manager'){
      user.ability = [
        {
          action: 'read',
          subject: 'Dash',
        },
        //Property
        {
          action: 'read',
          subject: 'Property',
        },
        {
          action: 'create',
          subject: 'Property',
        },
        {
          action: 'update',
          subject: 'Property',
        },
        {
          action: 'delete',
          subject: 'Property',
        },
        //place
        {
          action: 'read',
          subject: 'Place',
        },
        {
          action: 'create',
          subject: 'Place',
        },
        {
          action: 'update',
          subject: 'Place',
        },
         //enquiry
         {
          action: 'read',
          subject: 'Enquiry',
        },
        {
          action: 'create',
          subject: 'Enquiry',
        },
        {
          action: 'update',
          subject: 'Enquiry',
        },
        {
          action: 'delete',
          subject: 'Enquiry',
        },
        //Blog
        {
          action: 'read',
          subject: 'Blog',
        },
        {
          action: 'create',
          subject: 'Blog',
        },
        {
          action: 'update',
          subject: 'Blog',
        },
        {
          action: 'delete',
          subject: 'Blog',
        },
            //User
      {
        action: 'read',
        subject: 'User',
      },
      {
        action: 'create',
        subject: 'User',
      },
      {
        action: 'update',
        subject: 'User',
      },
      //Group Email
      {
        action: 'read',
        subject: 'GroupEmail',
      },
      {
        action: 'create',
        subject: 'GroupEmail',
      },
      {
        action: 'update',
        subject: 'GroupEmail',
      },
      {
        action: 'read',
        subject: 'CloseDeal',
      },
      {
        action: 'all',
        subject: 'CloseDeal',
      },
      {
        action: 'create',
        subject: 'CloseDeal',
      },
      {
        action: 'update',
        subject: 'CloseDeal',
      },
      {
        action: 'delete',
        subject: 'CloseDeal',
      },
      {
        action: 'read',
        subject: 'MailLog',
      },
      {
        action: 'read',
        subject: 'ai-bot',
      },
      ];
    }else if(user.role === 'Admin'){
      user.ability = [
        {
          action: 'read',
          subject:'Setting'
        },
        {
          action: 'read',
          subject: 'Dash',
        },
        {
          action: 'read',
          subject: 'Dash',
        },
        //Property
        {
          action: 'read',
          subject: 'Property',
        },
        {
          action: 'create',
          subject: 'Property',
        },
        {
          action: 'update',
          subject: 'Property',
        },
        {
          action: 'delete',
          subject: 'Property',
        },
        //place
        {
          action: 'read',
          subject: 'Place',
        },
        {
          action: 'create',
          subject: 'Place',
        },
        {
          action: 'update',
          subject: 'Place',
        },
        {
          action: 'delete',
          subject: 'Place',
        },
         //enquiry
         {
          action: 'read',
          subject: 'Enquiry',
        },
        {
          action: 'create',
          subject: 'Enquiry',
        },
        {
          action: 'update',
          subject: 'Enquiry',
        },
        {
          action: 'delete',
          subject: 'Enquiry',
        },
        //Blog
        {
          action: 'read',
          subject: 'Blog',
        },
        {
          action: 'create',
          subject: 'Blog',
        },
        {
          action: 'update',
          subject: 'Blog',
        },
        {
          action: 'delete',
          subject: 'Blog',
        },
          //User
      {
        action: 'read',
        subject: 'User',
      },
      {
        action: 'create',
        subject: 'User',
      },
      {
        action: 'update',
        subject: 'User',
      },
      //Group Email
      {
        action: 'read',
        subject: 'GroupEmail',
      },
      {
        action: 'create',
        subject: 'GroupEmail',
      },
      {
        action: 'update',
        subject: 'GroupEmail',
      },
      //Inventory
      {
        action: 'read',
        subject: 'Inventory List',
      },
      {
        action: 'create',
        subject: 'Inventory List',
      },
      {
        action: 'update',
        subject: 'Inventory List',
      },
      {
        action: 'read',
        subject: 'RoomType List',
      },
      {
        action: 'create',
        subject: 'RoomType List',
      },
      {
        action: 'update',
        subject: 'RoomType List',
      },
      {
        action:'update',
        subject:'Keyhand List'
      },
      //Hose Pin
      {
        action: 'read',
        subject: 'House Pin',
      },
      {
        action: 'read',
        subject: 'ai-bot',
      },
      {
        action: 'read',
        subject: 'MailLog',
      },
      ];

  }else if(user.role === 'Sale'){
    user.ability = [
      {
        action: 'read',
        subject: 'Dash',
      },
      //Property
      {
        action: 'read',
        subject: 'Property',
      },
      {
        action: 'create',
        subject: 'Property',
      },
      {
        action: 'update',
        subject: 'Property',
      },
      {
        action: 'delete',
        subject: 'Property',
      },
      //place
      {
        action: 'read',
        subject: 'Place',
      },
      {
        action: 'update',
        subject: 'Place',
      },
       //enquiry
       {
        action: 'read',
        subject: 'Enquiry',
      },
      {
        action: 'create',
        subject: 'Enquiry',
      },
      {
        action: 'update',
        subject: 'Enquiry',
      },
      {
        action: 'delete',
        subject: 'Enquiry',
      },
      //Blog
      {
        action: 'read',
        subject: 'Blog',
      },
      {
        action: 'create',
        subject: 'Blog',
      },
      {
        action: 'update',
        subject: 'Blog',
      },
      //User
      {
        action: 'read',
        subject: 'User',
      },
      {
        action: 'create',
        subject: 'User',
      },
      {
        action: 'update',
        subject: 'User',
      },
      {
        action: 'read',
        subject: 'CloseDeal',
      },
      {
        action: 'mine',
        subject: 'CloseDeal',
      },
      {
        action: 'read',
        subject: 'ai-bot',
      },
      {
        action: 'read',
        subject: 'MailLog',
      },
    ];

  }
  
    user.extras = {
      eCommerceCartItemsCount: user.eCommerceCartItemsCount,
    }
    console.log('login',user);
    try {
      const accessToken = user.token
      const refreshToken = user.refreshToken

      const userData = { ...user }

      delete userData.password

      const response = {
        userData,
        accessToken,
        refreshToken,
      }
      console.log('res', response)
      return [200, response]
    } catch (e) {
      console.log({e})
      error = e
    }
  } else {
    error = {
      email: ['Email or Password is Invalid'],
    }
  }

  return [400, { error }]
})

mock.onPost('/jwt/refresh-token').reply(async request => {
  const { refreshToken } = JSON.parse(request.data)

  try {
    const res = await axios.post('users/v1/refresh-token', { refreshToken })

    if (!res.data.success) {
      return [401, { error: res.data.message || 'Invalid refresh token' }]
    }

    const response = {
      accessToken: res.data.data.token,
      refreshToken: res.data.data.refreshToken,
    }

    return [200, response]
  } catch (e) {
    const error = 'Invalid refresh token'
    return [401, { error }]
  }
})
